const fontWeight = {
  100: 400,
  150: 500,
  200: 600,
};

export { fontWeight };
